import { useState } from 'react';

export const useAsyncFlow = <Args extends any[], Result>(
  callback: (...args: Args) => Promise<Result>,
) => {
  const [pending, setPending] = useState(false);
  const [result, setResult] = useState<Result | undefined>(undefined);
  const [error, setError] = useState<Error | undefined>(undefined);

  const clearState = () => {
    setPending(false);
    setError(undefined);
    setResult(undefined);
  };

  const execute = async (...args: Args) => {
    if (pending) return { success: false };
    clearState();
    try {
      setPending(true);
      const result = await callback(...args);
      setResult(result);
      return { success: true, result };
    } catch (e) {
      setError(e);
      return { success: false, error: e };
    } finally {
      setPending(false);
    }
  };

  return {
    execute,
    result,
    error,
    pending,
  };
};
